export const convertToByte = (text: string | undefined): number | undefined => {
  if (text === undefined) {
    return;
  }

  const trimmed = text.trim();
  if (trimmed.endsWith('G')) {
    return Number.parseInt(trimmed.slice(0, -1)) * 1024 * 1024 * 1024;
  } else if (trimmed.endsWith('M')) {
    return Number.parseInt(trimmed.slice(0, -1)) * 1024 * 1024;
  } else if (trimmed.endsWith('K')) {
    return Number.parseInt(trimmed.slice(0, -1)) * 1024;
  } else {
    return Number.parseInt(trimmed);
  }
};
